import { observable, toJS, computed, action } from "mobx";
import Reviews from "../@libs/Reviews";

class ProfileReviews extends Reviews {
	reviewsFilter = { active: true };
	sort = { created_at: -1 };

	constructor(rootStore, staticContext) {
		super(rootStore);
		this._items = staticContext.reviews || [];
		this._count = staticContext.reviewsCount;
		this.provider = staticContext.provider;
		this.reviewsFilter.provider = staticContext.provider
			? staticContext.provider._id
			: undefined;
	}

	get filter() {
		return this.reviewsFilter;
	}

	@observable _items = [];
	@computed
	get reviews() {
		return toJS(this._items);
	}

	@observable _count = 0;
	@computed
	get reviewsCount() {
		return toJS(this._count);
	}

	@action
	reset() {
		this._items = [];
		this._count = 0;
	}

	get avgRating() {
		return this.provider?.metrics.reviews_avg || 0;
		// const totalReviews = this.reviews.length;

		// if (totalReviews === 0) return 0;

		// const totalRating = this.reviews.reduce(
		// 	(result, review) => result + (review.rating || 0),
		// 	0
		// );

		// return (totalRating / totalReviews).toFixed(1);
	}
}

export default ProfileReviews;
